import { useInitData } from '../../../hooks'
import { BirdviewSkeletonLayout } from '../BirdviewSkeletonLayout'

import { useBirdviewOperationalWidgets } from './BirdviewOperational.hooks'
import { getBirdviewOperationalLayout } from './BirdviewOperational.utils'

function BirdviewOperational({
  activityDoneById,
  pendingIds,
  requestActions,
  sections,
  storageScope,
  onActivityToggle,
  onLoadAttentionGroup,
  onNavigate,
}) {
  const { sections: sectionsPermissions } = useInitData()

  const { tiles, widgets, widgetTitles } = useBirdviewOperationalWidgets({
    activityDoneById,
    pendingIds,
    requestActions,
    sections,
    onActivityToggle,
    onLoadAttentionGroup,
    onNavigate,
  })

  return (
    <BirdviewSkeletonLayout
      defaultLayout={getBirdviewOperationalLayout(sectionsPermissions)}
      storageScope={storageScope}
      tiles={tiles}
      widgets={widgets}
      widgetTitles={widgetTitles}
      onNavigate={onNavigate}
    />
  )
}

export default BirdviewOperational
